import {
  LOAD_LOCATIONS_INFO_FROM_CACHE,
  GET_LOCATIONS_INFO,
  SAVE_LOCATION_INFO,
  GET_LOCATION_SUGGESTIONS,
} from '../actions/locationManager'

const initiateState = {
  locations: {},
  isLoadingSuggestions: false,
  isLoadingLocationsInfo: false,
}

const locationManager = (state = initiateState, action = {}) => {
  let resultState = null
  switch (action.type) {
    case LOAD_LOCATIONS_INFO_FROM_CACHE.success:
      resultState = {
        ...state,
        locations: action.locations,
      }
      break
    case GET_LOCATIONS_INFO.action:
      resultState = {
        ...state,
        isLoadingLocationsInfo: true,
      }
      break
    case GET_LOCATIONS_INFO.success:
      resultState = {
        ...state,
        locations: action.locations,
        isLoadingLocationsInfo: false,
      }
      break
    case GET_LOCATION_SUGGESTIONS.action:
      resultState = {
        ...state,
        isLoadingSuggestions: true,
      }
      break
    case GET_LOCATION_SUGGESTIONS.success:
      resultState = {
        ...state,
        locations: action.locations,
        isLoadingSuggestions: false,
      }
      break
    case SAVE_LOCATION_INFO.success:
      resultState = {
        ...state,
        locations: action.locations,
      }
      break
    default:
      return state
  }

  if (!resultState) {
    resultState = {
      ...state,
    }
  }

  return resultState
}

export default locationManager
